import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/core/api/navigation.service';
import { PatientService } from 'src/app/core/api/patient.service';
import { patientSideNavSchema } from 'src/app/core/schemas/navigation-schema';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { LoadingSpinnerService } from 'src/app/shared/loading-spinner/loading-spinner.service';
import { EConsultFormGroup } from '../../econsult/econsult-form.model';
import { TabletQuestionnaireModalComponent } from '../../shared/tablet-questionnaire-modal/tablet-questionnaire-modal.component';
import { EncountersRoutes } from '../encounters.routes';
import { AssessmentService } from './../../core/api/assessment.service';
import { SendQuestionnaireDialogComponent } from './../../shared/send-questionnaire-dialog/send-questionnaire-dialog.component';
import {
  EncountersCompareModalComponent,
  EncountersToCompare
} from './../encounters-compare-modal/encounters-compare-modal.component';
@Component({
  selector: 'csi-encounter-dashboard',
  templateUrl: './encounter-dashboard.component.html',
  styleUrls: ['./encounter-dashboard.component.scss'],
  providers: [AssessmentService, EConsultFormGroup]
})
export class EncounterDashboardComponent implements OnInit {
  EncountersRoutes = EncountersRoutes;
  assessmentIdToExpand: string;
  assessmentRowHoveredId: string;
  encountersToCompare: EncountersToCompare = [];
  treatmentPicker: any;
  isLoading: boolean;
  invoices: any[] = [];
  assessments = [];
  translocoFileKey = 'dashboard.patients-dashboard.';
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public assessmentService: AssessmentService,
    public patientService: PatientService,
    public appStateService: AppStateService,
    public loadingSpinnerService: LoadingSpinnerService,
    private dialog: MatDialog,
    public formGroup: EConsultFormGroup,
    private navigationService: NavigationService
  ) {}
  ngOnInit() {
    this.navigationService.updateSideNavSchema(patientSideNavSchema);
    this.assessments = this.patientService.assessments.map(raw => {
      const parsed = JSON.parse(raw.body || '{}').assessmentForm || {};
      return {
        id: parsed.id || '',
        name: parsed.name || 'Untitled',
        date: parsed.date || '',
        recommendedTreatments: parsed.recommendedTreatments || []
      };
    });
    if (
      this.patientService.patient &&
      this.patientService.patient.clinic &&
      this.patientService.patient.clinic.id
    ) {
      const filter = { treatmentPlanClinicId: { eq: this.patientService.patient.clinic.id } };
    }
  }

  openTabletQuestionnaire() {
    TabletQuestionnaireModalComponent.open(this.dialog, null, this.patientService.patient)
      .afterClosed()
      .subscribe(questionnaireRequestGenerated => {
        if (questionnaireRequestGenerated) {
          this.patientService.questionnaires = [
            questionnaireRequestGenerated,
            ...this.patientService.questionnaires
          ];
        }
      });
  }
  openSendQuestionnaire() {
    SendQuestionnaireDialogComponent.open(
      this.dialog,
      null,
      this.appStateService.getCurrentPatient(),
      {},
      null,
      true
    )
      .afterClosed()
      .subscribe(questionnaireRequestsSent => {
        if (questionnaireRequestsSent) {
          if (!Array.isArray(questionnaireRequestsSent)) {
            questionnaireRequestsSent = [questionnaireRequestsSent];
          }
          this.patientService.questionnaires = [
            ...questionnaireRequestsSent,
            ...this.patientService.questionnaires
          ];
        }
      });
  }
  openEncountersCompare() {
    EncountersCompareModalComponent.open(this.dialog, this.encountersToCompare);
  }
  routeToNewEncounter() {
    this.router.navigate([{ outlets: { encounters: EncountersRoutes.New } }], {
      relativeTo: this.route.parent
    });
  }
}
